<div [ngClass]="$safeNavigationMigration(modalContent?.styleClass)">
    <h1 mat-dialog-title>{{ modalContent?.title }}</h1>
    <p [innerHTML]="message"></p>
    <div mat-dialog-actions class="actions">
        <app-button [label]="'action.cancel' | translate" [color]="'grey'" (buttonClick)="onActionTaken(false)"></app-button>
        <app-button [label]="$safeNavigationMigration(modalContent?.ok)" [color]="modalContent.severity ?? 'primary'" (buttonClick)="onActionTaken(true)"></app-button>
    </div>
</div>



